import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 2em;

    .title-row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .block-title {
            width: 100%;

            .title {
                font-size: 2em;
            }

            .page-info {
                font-size: 0.9em;
                color: ${vars.colorTextLight};
                margin-top: 0.4em;
            }
        }

        .block-filters {
            width: 35%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .layout-forms-input-wrapper {
                margin-bottom: 0;

                .label-wrapper {
                    display: none;
                }
            }


            .input-body {
                border: .01em solid #000000;
                border-radius: .33em;
            }

            [class$=control] {
                height: 3.1em;
            }

            [class$=indicatorSeparator] {
                display: none;
            }

            [class$=indicatorContainer] {
                color: #000000;
            }

            [class$=menu] {
                border: .01em solid #000000;
            }

            .filter {
                width: 100%;
                max-width: 15em;
            }
        }
    }

    .options-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 2em;
        width: 100%;

        .option {
            width: 100%;
            max-width: 40em;

            .label {
                vertical-align: middle;
            }
        }
    }
    .sort-label {
        display: flex;
        align-items: center;
    }
    .layout-tooltip {
            padding: 0 .1em;
        }
    #tooltip-sort {
            max-width: 20em;
        }
    @media all and (max-width: ${vars.mobileL}) {
        .title-row {
            flex-direction: column-reverse;

            .block-title {
                padding-top: 3em;

                .title {
                    b {
                        display: none;
                    }
                }
            }

            .block-filters {
                width: 100%;

                .title {
                    display: none;
                }

                .filter {
                    max-width: 100%;
                }

                .name-newest {
                    font-size: 1.2em;

                    .select-newest__menu,
                    .select-newest__single-value {
                        font-size: 1.26em;
                        -webkit-appearance: none;
                    }
                }
            }
        }
        .sort-label {
            padding: 0 1em;
        }
         .layout-tooltip {
            padding: 0;
        }
    }
`;